import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import { fetchHistoryFailure, fetchHistorySuccess } from "./actions";
import { FETCH_HISTORYS } from "./constants";

export function* fetchHistorySaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/credit-history?${query}`);
    yield put(fetchHistorySuccess(data));
  } catch (e) {
    yield put(fetchHistoryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching history list!"));
  }
}

export function* fetchHistoryFlow() {
  yield takeEvery(FETCH_HISTORYS, fetchHistorySaga);
}

export default function* HistorySaga() {
  yield all([fetchHistoryFlow()]);
}
